import request from './request';

export default {
	async getInvoices(query) {
		const response = await request.get('/app/invoices', query);
		return response;
	}
};
